import React from 'react';
import {
  BrowserRouter as Router
} from "react-router-dom";
import { createBrowserHistory } from "history";
import StripeScriptLoader from 'react-stripe-script-loader'


import Routes from 'routes';

import translations from 'translations';

import 'normalize.css/normalize.css';
import '@blueprintjs/icons/lib/css/blueprint-icons.css';
import '@blueprintjs/core/lib/css/blueprint.css'

import './App.css';

const customHistory = createBrowserHistory();

const App = () => {
  /**
   * To enforce polyfill for smoothscroll-polyfill module
   */
  window.__forceSmoothScrollPolyfill__ = true;

  return (
    <StripeScriptLoader
      uniqueId='stripe-js'
      script='https://js.stripe.com/v3/'
      loader="..."
    >
      <div className="App">
        <Router history={customHistory}>
          <Routes translations={translations}/>
        </Router>
      </div>
    </StripeScriptLoader>
      
  );
}

export default App;
